import { useEffect, useState } from 'react';

export type Theme = 'light' | 'dark';

const STORAGE_KEY = 'ctp_theme';

/**
 * Globales Theme: persistiert in localStorage (`ctp_theme`) und schaltet die
 * `dark`-Klasse am <html>. Wird von Portal (Layout) und öffentlicher Landing
 * Page gemeinsam genutzt, damit die Wahl überall konsistent bleibt.
 *
 * Standard = Dark: Neue Besucher (ohne gespeicherte Wahl) landen im Dark Mode;
 * nur eine ausdrücklich gewählte Light-Einstellung weicht davon ab. Das frühe
 * Setzen in `main.tsx` verhindert einen Flash beim ersten Laden.
 */
export function useTheme(): {
  theme: Theme;
  dark: boolean;
  setTheme: (t: Theme) => void;
  toggle: () => void;
} {
  const [theme, setTheme] = useState<Theme>(() =>
    localStorage.getItem(STORAGE_KEY) === 'light' ? 'light' : 'dark',
  );

  useEffect(() => {
    document.documentElement.classList.toggle('dark', theme === 'dark');
    localStorage.setItem(STORAGE_KEY, theme);
  }, [theme]);

  return {
    theme,
    dark: theme === 'dark',
    setTheme,
    toggle: () => setTheme((t) => (t === 'dark' ? 'light' : 'dark')),
  };
}
